module.exports = __webpack_public_path__ + "img/Usable.c1c76c61.svg";